import { useState, useEffect } from 'react';
import { useApi, githubAuthApiRef } from '@backstage/core-plugin-api';
import { fetchUserTeams, GithubTeam } from './githubApi';

interface UseUserTeamsResult {
  teams: GithubTeam[];
  loading: boolean;
  error: string | null;
}

/**
 * Fetch the authenticated user's GitHub teams, optionally filtered to a specific org.
 */
export function useUserTeams(owner?: string): UseUserTeamsResult {
  const [teams, setTeams] = useState<GithubTeam[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const githubAuth = useApi(githubAuthApiRef);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await githubAuth.getAccessToken(['read:org']);
        const result = await fetchUserTeams(token, owner);
        setTeams(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch user teams');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [githubAuth, owner]);

  return { teams, loading, error };
}
